import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from './Input.style.module.scss';

class Input extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    hasError: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    className: PropTypes.string,
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    paddingLeft30: PropTypes.bool,
    type: PropTypes.oneOf([
      'date',
      'datetime-local',
      'email',
      'month',
      'number',
      'password',
      'search',
      'tel',
      'text',
      'textarea',
      'time',
      'url',
      'week',
      'hidden'
    ]),
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    dataTestId: PropTypes.string
  };

  static defaultProps = {
    type: 'text',
    paddingLeft30: false
  };

  constructor(props) {
    super(props);
    const { type } = this.props;
    this.inputRef = React.createRef();
    this.isTextarea = type === 'textarea';
    this.state = {
      cursor: null
    };
  }

  componentDidUpdate() {
    const { cursor } = this.state;
    if (this.inputRef && this.inputRef.current && !this.isTextarea && cursor !== null) {
      this.inputRef.current.setSelectionRange(cursor, cursor);
    }
  }

  render() {
    const {
      id,
      className,
      disabled,
      readOnly,
      onChange,
      required,
      inputRef,
      type,
      value,
      defaultValue,
      hasError,
      paddingLeft30 = false,
      placeholder,
      dataTestId
    } = this.props;

    this.inputRef = inputRef || this.inputRef;

    const Element = this.isTextarea ? 'textarea' : 'input';
    const autoComplete =
      ['cardNumber', 'documentNumber'].includes(id) || (placeholder && placeholder.match(/CARD/i))
        ? 'off'
        : 'on';

    const handleChange = (e) => {
      if (disabled || readOnly || !onChange) {
        return;
      }
      this.setState({ cursor: e.target.selectionStart });
      onChange(e.target.value);
    };

    const onBlur = () => {
      this.setState({ cursor: null });
    };

    return (
      <div
        className={classNames(
          'inputWrapper',
          classes.inputWrapper,
          className,
          paddingLeft30 && classes.leftPadding30Perc,
          hasError && classes.hasError
        )}
      >
        <Element
          id={id}
          name={id}
          data-testid={dataTestId}
          autoComplete={autoComplete}
          disabled={disabled}
          required={required}
          onChange={handleChange}
          onBlur={onBlur}
          readOnly={readOnly}
          placeholder={placeholder}
          ref={this.inputRef}
          type={this.isTextarea ? null : type}
          value={value ?? ''}
          defaultValue={defaultValue}
        />
        {hasError && <div className={classes.error}>{hasError}</div>}
      </div>
    );
  }
}

export default Input;
